import { isDevelopment } from "./config/env";

// src/bootstrap.ts
async function injectRemoteHead() {
  try {
    const res = await fetch("/remote-head", {
      credentials: "include",
      headers: { Accept: "text/html" },
    });
    if (!res.ok) {
      console.warn("fetch /remote-head failed", res.status);
      return;
    }

    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const metas = Array.from(doc.querySelectorAll("meta"));
    metas.forEach(meta => {
      const newMeta = document.createElement("meta");
      for (let i = 0; i < meta.attributes.length; i++) {
        const attr = meta.attributes[i];
        newMeta.setAttribute(attr.name, attr.value);
      }
      // 如果已有相同 name / property，先删除旧的再添加
      const key =
        meta.getAttribute("name") || meta.getAttribute("property") || "";
      if (key) {
        document.head
          .querySelectorAll(`meta[name="${key}"], meta[property="${key}"]`)
          .forEach(old => old.remove());
      }
      document.head.appendChild(newMeta);
    });

    const inlineScripts = Array.from(doc.querySelectorAll("script:not([src])"));
    inlineScripts.forEach(s => {
      const code = s.textContent || "";
      // 提取 window.* 赋值语句
      const matchLines = code.match(/window\.[\w$_.]+\s*=\s*[^;]+;/g);
      if (matchLines) {
        matchLines.forEach(line => {
          try {
            // 只执行安全的赋值语句
            eval(line);
          } catch (e) {
            console.warn("Skip unsafe line:", e);
          }
        });
      }
    });
  } catch (err) {
    console.error("injectRemoteHead error:", err);
  }
}

(async () => {
  if (isDevelopment) {
    await injectRemoteHead();
  }
  await import("./main");
})();
